import React from 'react'

// Statyczne importy wszystkich flag krajów
import PLFlag from 'src/assets/images/country_flags/pl.svg'
import DEFlag from 'src/assets/images/country_flags/de.svg'
import UAFlag from 'src/assets/images/country_flags/ua.svg'
import RUFlag from 'src/assets/images/country_flags/ru.svg'
import SKFlag from 'src/assets/images/country_flags/sk.svg'
import DKFlag from 'src/assets/images/country_flags/dk.svg'
import LTFlag from 'src/assets/images/country_flags/lt.svg'
import SIFlag from 'src/assets/images/country_flags/si.svg'
import CZFlag from 'src/assets/images/country_flags/cz.svg'
import FRFlag from 'src/assets/images/country_flags/fr.svg'
import UZFlag from 'src/assets/images/country_flags/uz.svg'
import LVFlag from 'src/assets/images/country_flags/lv.svg'
import NLFlag from 'src/assets/images/country_flags/nl.svg'
import ROFlag from 'src/assets/images/country_flags/ro.svg'
import EEFlag from 'src/assets/images/country_flags/ee.svg'
import ATFlag from 'src/assets/images/country_flags/at.svg'
import HUFlag from 'src/assets/images/country_flags/hu.svg'
import LIFlag from 'src/assets/images/country_flags/li.svg'
import FIFlag from 'src/assets/images/country_flags/fi.svg'
import IEFlag from 'src/assets/images/country_flags/ie.svg'
import MDFlag from 'src/assets/images/country_flags/md.svg'
import ESFlag from 'src/assets/images/country_flags/es.svg'
import NOFlag from 'src/assets/images/country_flags/no.svg'
import BGFlag from 'src/assets/images/country_flags/bg.svg'
import GBFlag from 'src/assets/images/country_flags/gb.svg'
import ITFlag from 'src/assets/images/country_flags/it.svg'
import TRFlag from 'src/assets/images/country_flags/tr.svg'
import BYFlag from 'src/assets/images/country_flags/by.svg'
import ALFlag from 'src/assets/images/country_flags/al.svg'
import HRFlag from 'src/assets/images/country_flags/hr.svg'
import SEFlag from 'src/assets/images/country_flags/se.svg'
import GRFlag from 'src/assets/images/country_flags/gr.svg'
import BEFlag from 'src/assets/images/country_flags/be.svg'
import SMFlag from 'src/assets/images/country_flags/sm.svg'
import AZFlag from 'src/assets/images/country_flags/az.svg'

// Mapa wszystkich flag krajów
const commonFlags = {
  pl: PLFlag,
  de: DEFlag,
  ua: UAFlag,
  ru: RUFlag,
  sk: SKFlag,
  dk: DKFlag,
  lt: LTFlag,
  si: SIFlag,
  cz: CZFlag,
  fr: FRFlag,
  uz: UZFlag,
  lv: LVFlag,
  nl: NLFlag,
  ro: ROFlag,
  ee: EEFlag,
  at: ATFlag,
  hu: HUFlag,
  li: LIFlag,
  fi: FIFlag,
  ie: IEFlag,
  md: MDFlag,
  es: ESFlag,
  no: NOFlag,
  bg: BGFlag,
  gb: GBFlag,
  it: ITFlag,
  tr: TRFlag,
  by: BYFlag,
  al: ALFlag,
  hr: HRFlag,
  se: SEFlag,
  gr: GRFlag,
  be: BEFlag,
  sm: SMFlag,
  az: AZFlag
}

// Czysty komponent CountryFlag - renderuje tylko SVG bez stylowania
const CountryFlag = ({ countryCode, className, ...props }) => {
  if (!countryCode) return null

  const code = countryCode.toLowerCase()

  // Sprawdź czy flaga istnieje w mapie
  if (commonFlags[code]) {
    const StaticFlag = commonFlags[code]
    return <StaticFlag className={className} {...props} />
  }

  // Jeśli flaga nie istnieje, zwróć null
  console.warn(`Flag for country code "${countryCode}" not found`)
  return null
}

export default CountryFlag
